// Step component
import clsx from 'clsx'
import { CheckIcon } from '@heroicons/react/24/solid'

type StepProps = {
  id: number
  label: string
  status: string
  //    'complete' | 'current' | 'upcoming'
}

export function Step({ id, label, status }: StepProps) {
  return (
    <li key={id} className="relative overflow-hidden md:flex-1">
      <div className={clsx(id === 1 ? 'border-b-0' : '', id === 3 ? 'border-t-0' : '', 'overflow-hidden border border-gray-200 md:border-0')}>
        <div className="group">
          <span
            className={clsx('absolute left-0 top-0 h-full w-1 md:bottom-0 md:top-auto md:h-1 md:w-full', {
              'bg-transparent group-hover:bg-gray-200': status !== 'current',
              'bg-primary': status === 'current',
            })}
            aria-hidden="true"
          />
          <span className={clsx(id !== 1 ? 'md:pl-9' : '', 'flex items-center px-6 py-5 text-sm font-medium')}>
            <span className="flex-shrink-0">
              <span
                className={clsx('flex h-10 w-10 items-center justify-center rounded-full', {
                  'bg-green-600': status === 'complete',
                  'border-2 border-primary': status === 'current',
                  'border-2 border-gray-300': status === 'upcoming',
                })}
              >
                {status === 'complete' ? (
                  <CheckIcon className="h-6 w-6 text-white" aria-hidden="true" />
                ) : (
                  <span className={clsx({ 'text-primary': status === 'current', 'text-gray-500': status === 'upcoming' })}>{id}</span>
                )}
              </span>
            </span>
            <span className="ml-4 flex min-w-0 flex-col">
              <span className="text-sm font-medium">{label}</span>
            </span>
          </span>
        </div>
        {id !== 1 ? (
          <>
            {/* Separator */}
            <div className="absolute inset-0 left-0 top-0 hidden w-3 md:block" aria-hidden="true">
              <svg className="h-full w-full text-gray-300" viewBox="0 0 12 82" fill="none" preserveAspectRatio="none">
                <path d="M0.5 0V31L10.5 41L0.5 51V82" stroke="currentcolor" vectorEffect="non-scaling-stroke" />
              </svg>
            </div>
          </>
        ) : null}
      </div>
    </li>
  )
}
